import { useStaticQuery, graphql } from 'gatsby'
export const useGlobalDataEN = () => {
  const { datoCmsResturantInformation } = useStaticQuery(graphql`
    query GlobalQueryEn {
      datoCmsResturantInformation(locale: "en") {
        address
        email
        facebookLink
        instagramLink
        phone
        pinterestLink
        schedule1Title
        schedule1Content
        schedule2Title
        schedule2Content
        linkedinLink
      }
      locales: allLocale {
        edges {
          node {
            ns
            data
            language
          }
        }
      }
    }
  `)
  return datoCmsResturantInformation
}
